var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllergenMilk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9503 5C19.7109 5 20.3518 5.61626 20.4855 6.45148L20.5038 6.60106L20.5101 6.75811L20.508 8.84356L22.9635 13.1194L23 13.2586V28H9V13.3203L9.04382 13.1691L11.7865 8.94271L11.788 6.75794C11.788 6.01427 12.2005 5.36739 12.8015 5.11249L12.9331 5.06398L13.07 5.02811L13.2163 5.00639L13.3478 5H18.9503ZM19.7601 10.6672L18.0377 13.6674V26.3604H21.5467V13.7472L19.7601 10.6672ZM12.7664 10.2052H18.296L16.6235 13.1194L16.5871 13.2586L16.5862 26.3604H10.4506L10.4497 14.8992L14.4541 14.9011V13.451L10.6592 13.4507L12.7664 10.2052ZM18.9504 6.6379H13.3478C13.3091 6.6379 13.2747 6.66087 13.2572 6.68471L13.2458 6.70801L13.2402 6.758L13.2389 8.75564H19.0574L19.0581 6.75795C19.0581 6.71524 19.0378 6.67688 19.0163 6.6572L18.995 6.64426L18.9504 6.6379ZM12.1111 25.3462C12.5407 25.3462 12.8889 24.9501 12.8889 24.4615C12.8889 23.973 12.5407 23.5769 12.1111 23.5769C11.6816 23.5769 11.3333 23.973 11.3333 24.4615C11.3333 24.9501 11.6816 25.3462 12.1111 25.3462Z",
    fill: "current",
    className: "filled",
    strokeWidth: 0
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllergenMilk);
export default __webpack_public_path__ + "static/media/AllergenMilk.ad26ddd6.svg";
export { ForwardRef as ReactComponent };